var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',_vm._l((_vm.locations),function(location){return _c('v-list-item',{key:location.uid},[_c('v-list-item-content',[_vm._v(_vm._s(location.title))]),_c('v-list-item-action',[_c('v-btn',{attrs:{"fab":"","icon":"","to":{ name: 'locations/details', params: { uid: location.uid } }}},[_c('v-icon',[_vm._v("folder")])],1)],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }